<template>
  <div class="alert alert-custom alert-light-warning py-3 mb-4">
    <div class="alert-text">
      <div class="font-weight-bolder mb-2">Phiếu có máy Tồn kho thu cũ</div>
      <b-form-checkbox
        :checked="value"
        :disabled="disabled"
        @change="$emit('input', $event)"
      >
        Được bán
      </b-form-checkbox>
      <small class="text-muted">
        Tick thì máy thành Mới khi kho đến xác nhận; không tick thì vẫn là Tồn
        kho thu cũ.
      </small>
    </div>
  </div>
</template>

<script>
// t103002: lựa chọn "Được bán" của phiếu chuyển máy tồn kho thu cũ, dùng chung màn tạo / sửa phiếu
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
